import React, { useEffect, useState } from "react";
import Header from "../Components/header";
import Sidebar from "../Components/sidebar";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  gql,
  useMutation,
} from "@apollo/client";
import * as Icons from "react-icons/fa";
import * as Fa6Icons from "react-icons/fa6";

const API_KEY =
  "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE3MTYxOTQ4MDEsImF1ZCI6WyJodHRwczovL2FwaS1ldS1jZW50cmFsLTEtc2hhcmVkLWV1YzEtMDIuaHlncmFwaC5jb20vdjIvY2x3ZXEybTZhMDAwMDAxdzY3YXF6ZWg3eC9tYXN0ZXIiLCJtYW5hZ2VtZW50LW5leHQuZ3JhcGhjbXMuY29tIl0sImlzcyI6Imh0dHBzOi8vbWFuYWdlbWVudC1ldS1jZW50cmFsLTEtc2hhcmVkLWV1YzEtMDIuaHlncmFwaC5jb20vIiwic3ViIjoiZWYwZWJjYjEtM2IwNi00NjQ2LWFiNTItMWQwMmVlMzJmNzZmIiwianRpIjoiY2tsdXpicmxwNW9sOTAxeHY3MzI1OHRqZCJ9.j6_FyV0D25iUBrQB5EgA_e0IM-ABoTBW8E2lst5jNpC7jpkoefd98lxsIArNC4aM6E5_9MDUDF3aBZpE2vhQv8L0MXwwehcg4cyRJgZ8Ve9tTzLH5ZmZnMdN9L2EsuNxoZ9KHb50VT3-6sBHphWuXun-ufIQovt3p_WG_Fbs6X9exukEHW46y2B0YGM6D-h49g3PWg4YIcPcKoU2AOzk4LHFewzKzqvkaekAj0SZXxTIfqhpfvjafqhDKVUjTqcpo9TrGXuR7Mj8t0skdQg-p9LEHQ6StY3OjRS7iZt9EuQg21iG1A6--_m7PniC70kx494Y_CjsQvaEb3noHgav0XT5qRDVX_sru1zPLG12e-xcMPIceIej40E9oyN4HXETQn9I5zuDj7o6Fnqa8anIaf21C52qVEfD7XTOjC9ug9RwEb5Ix2r404SMNL8V5pKn81WsDE3tziYvfqm3nEf9NYSWASsVsidr_SGUFt6oGJIFF_D25jQtpnwjLpWytN7KrsG8T3t6SHa1rtGh2wf9WEaetA6qARUBJawgZD6TPNUTj7vflkzwNYFFM4dHNpaJj-tBUcTOcsutd_FLSLu5zLkbkFlDdyTUasSZGM_pZqeREHdpvKL8OZbIVSjt_NzxQp2aF3mHyQafE5PuZtjnlZBLkzmTUMa8Rf8FKtIKdIU"; // Sostituisci con la tua API key

const client = new ApolloClient({
  uri: "https://eu-central-1-shared-euc1-02.cdn.hygraph.com/content/clweq2m6a000001w67aqzeh7x/master",
  cache: new InMemoryCache(),
  headers: {
    Authorization: `Bearer ${API_KEY}`,
  },
});

// Query per ottenere le FAQ
const FAQs = gql`
  query MyQuery {
    faqs {
      id
      titoloFaq
      descrizione
      categoriaFaq {
        id
        titoloCategoria
      }
    }
  }
`;
const CATEGORIE = gql`
  query MyQuery {
    categorieFaq {
      id
      titoloCategoria
      icona
    }
  }
`;

// Mutation per aggiornare una FAQ
const UPDATE_FAQ = gql`
  mutation UpdateFAQ(
    $id: ID!
    $titoloFaq: String!
    $descrizione: String!
    $categoriaFaq: ID!
  ) {
    updateFaq(
      where: { id: $id }
      data: {
        titoloFaq: $titoloFaq
        descrizione: $descrizione
        categoriaFaq: { connect: { id: $categoriaFaq } }
      }
    ) {
      id
      titoloFaq
      descrizione
    }
    publishFaq(where: { id: $id }) {
      id
      titoloFaq
      descrizione
    }
    publishCategoriaFaq(where: { id: $categoriaFaq }) {
      id
    }
  }
`;

// Mutation per aggiungere una nuova FAQ
const ADD_FAQ = gql`
  mutation AddFAQ(
    $titoloFaq: String!
    $descrizione: String!
    $categoriaFaq: ID
  ) {
    createFaq(
      data: {
        titoloFaq: $titoloFaq
        descrizione: $descrizione
        categoriaFaq: { connect: { id: $categoriaFaq } }
      }
    ) {
      id
      titoloFaq
      descrizione
    }
    publishFaq(where: { titoloFaq: $titoloFaq }) {
      id
      titoloFaq
      descrizione
    }
    publishCategoriaFaq(where: { id: $categoriaFaq }) {
      id
    }
  }
`;

const DELETE_FAQ = gql`
  mutation DeleteFAQ($id: ID!) {
    deleteFaq(where: { id: $id }) {
      id
    }
  }
`;

// Mutation per aggiungere una nuova categoria
const ADD_CATEGORIA = gql`
  mutation AddCategoria($titoloCategoria: String!, $icona: String!) {
    createCategoriaFaq(
      data: { titoloCategoria: $titoloCategoria, icona: $icona }
    ) {
      id
      titoloCategoria
    }
    publishCategoriaFaq(where: { titoloCategoria: $titoloCategoria }) {
      id
      titoloCategoria
    }
  }
`;

// Mutation per aggiornare una categoria
const UPDATE_CATEGORIA = gql`
  mutation UpdateCategoria(
    $id: ID!
    $titoloCategoria: String!
    $icona: String!
  ) {
    updateCategoriaFaq(
      where: { id: $id }
      data: { titoloCategoria: $titoloCategoria, icona: $icona }
    ) {
      id
      titoloCategoria
      icona
    }
    publishCategoriaFaq(where: { id: $id }) {
      id
      titoloCategoria
      icona
    }
  }
`;

// Mutation per eliminare una categoria
const DELETE_CATEGORIA = gql`
  mutation DeleteCategoria($id: ID!) {
    deleteCategoriaFaq(where: { id: $id }) {
      id
    }
  }
`;

const GestioneFAQs = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [faqs, setFAQs] = useState([]);
  const [editingId, setEditingId] = useState(null); // Traccia della FAQ in modifica
  const [editData, setEditData] = useState({
    titoloFaq: "",
    descrizione: "",
    categoriaFaq: "",
  });
  const [selectedCategoria, setSelectedCategoria] = useState("");

  const { data, loading, error } = useQuery(FAQs);
  const { data: categorieData } = useQuery(CATEGORIE);
  const [createFAQ] = useMutation(ADD_FAQ);
  const [updateFAQ] = useMutation(UPDATE_FAQ);
  const [deleteFAQ] = useMutation(DELETE_FAQ);

  useEffect(() => {
    if (data?.faqs) {
      console.log(data);
      setFAQs(data.faqs.map((faq) => ({ ...faq, open: false })));
    }
  }, [data]);

  const filteredFAQs = faqs.filter(
    (faq) =>
      faq.titoloFaq.toLowerCase().includes(searchTerm.toLowerCase()) ||
      faq.descrizione.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleFAQ = (index) => {
    setFAQs((prevFAQs) =>
      prevFAQs.map((faq, i) =>
        i === index ? { ...faq, open: !faq.open } : faq
      )
    );
  };

  const startEditing = (faq) => {
    setEditingId(faq.id);
    setEditData({
      titoloFaq: faq.titoloFaq,
      descrizione: faq.descrizione,
    });
  };

  const cancelEditing = () => {
    setEditingId(null);
    setEditData({ titoloFaq: "", descrizione: "", categoriaFaq: "" });
  };

  const handleSave = async () => {
    try {
      const variables = {
        id: editingId,
        titoloFaq: editData.titoloFaq,
        descrizione: editData.descrizione,
        categoriaFaq:
          selectedCategoria ||
          faqs.find((faq) => faq.id === editingId).categoriaFaq.id,
      };

      await updateFAQ({ variables });
      setFAQs((prevFAQs) =>
        prevFAQs.map((faq) =>
          faq.id === editingId ? { ...faq, ...editData } : faq
        )
      );
      cancelEditing();
      window.location.reload();
    } catch (error) {
      console.error("Errore durante l'aggiornamento:", error);
    }
  };

  const handleDeleteFAQ = async (item) => {
    try {
      const variables = {
        id: item.id,
      };

      await deleteFAQ({ variables });
      setFAQs((prevFAQs) =>
        prevFAQs.map((faq) =>
          faq.id === editingId ? { ...faq, ...editData } : faq
        )
      );
      cancelEditing();
      window.location.reload();
    } catch (error) {
      console.error("Errore durante l'aggiornamento:", error);
    }
  };

  const handleCreateFaq = async (e) => {
    e.preventDefault();
    try {
      const variables = {
        titoloFaq: editData.titoloFaq,
        descrizione: editData.descrizione,
        categoriaFaq: selectedCategoria || "1",
      };
      await createFAQ({ variables });
      window.location.reload();
    } catch (error) {
      console.error("Errore durante la creazione della FAQ:", error);
    }
    // Resetta i campi dopo la creazione
    setEditData({ titoloFaq: "", descrizione: "", categoriaFaq: "" });
    setSelectedCategoria("");
  };

  const handleCategoriaChange = (selectedId) => {
    console.log("Categoria selezionata:", selectedId);
    setSelectedCategoria(selectedId);
  };

  if (loading) return <p>Caricamento in corso...</p>;
  if (error) return <p>Errore durante il caricamento: {error.message}</p>;

  return (
    <div>
      <Header />
      <div className="flex min-h-screen">
        <Sidebar />
        <div className="flex-1 p-6 bg-gray-100">
          <GestioneCategorie />

          <h1 className="text-3xl font-bold mb-6">Gestione FAQs</h1>
          {/* Sezione per la creazione di una nuova FAQ */}
          <div className="p-4 bg-white shadow rounded mb-6">
            <h2 className="text-2xl font-bold mb-4">Crea una nuova FAQ</h2>
            <form onSubmit={handleCreateFaq}>
              <input
                type="text"
                placeholder="Titolo"
                value={editData.titoloFaq}
                onChange={(e) =>
                  setEditData((prev) => ({
                    ...prev,
                    titoloFaq: e.target.value,
                  }))
                }
                className="w-full mb-2 p-2 border rounded"
                required
              />
              <textarea
                placeholder="Descrizione"
                value={editData.descrizione}
                onChange={(e) =>
                  setEditData((prev) => ({
                    ...prev,
                    descrizione: e.target.value,
                  }))
                }
                className="w-full mb-2 p-2 border rounded"
                required
              />
              <select
                value={selectedCategoria}
                onChange={(e) => handleCategoriaChange(e.target.value)}
                className="w-full mb-4 p-2 border rounded"
              >
                <option value="">Seleziona una categoria</option>
                {categorieData?.categorieFaq.map((categoria) => (
                  <option key={categoria.id} value={categoria.id}>
                    {categoria.titoloCategoria}
                  </option>
                ))}
              </select>
              <button
                type="submit"
                className="bg-blue-500 text-white px-4 py-2 rounded shadow hover:bg-blue-700"
              >
                Crea FAQ
              </button>
            </form>
          </div>
          <div className="flex items-center gap-4 mb-6">
            <input
              type="text"
              placeholder="Cerca FAQ"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="flex-grow p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              onClick={handleCreateFaq}
              className="flex items-center gap-2 bg-blue-600 text-white px-5 py-3 rounded shadow hover:bg-blue-700 transition"
            >
              <span>Aggiungi</span>
            </button>
          </div>
          <div className="grid grid-cols-1 gap-x-10">
            {filteredFAQs.map((item, index) => (
              <div
                key={index}
                className={`wrapper text-left mb-4 ${
                  item.open
                    ? "border-2 border-blue-500"
                    : "border border-gray-300"
                } p-4 rounded-md ease-in-out grid transition-all`}
              >
                {editingId === item.id ? (
                  // Modalità modifica
                  <div>
                    <input
                      type="text"
                      value={editData.titoloFaq}
                      onChange={(e) =>
                        setEditData((prev) => ({
                          ...prev,
                          titoloFaq: e.target.value,
                        }))
                      }
                      className="border p-2 rounded w-full mb-2"
                    />
                    <textarea
                      value={editData.descrizione}
                      onChange={(e) =>
                        setEditData((prev) => ({
                          ...prev,
                          descrizione: e.target.value,
                        }))
                      }
                      className="border p-2 rounded w-full mb-2"
                    />

                    <select
                      defaultValue={item.categoriaFaq?.id || ""}
                      onChange={(e) => handleCategoriaChange(e.target.value)} // Funzione per gestire il cambiamento
                      className="border p-2 rounded  mr-2"
                    >
                      <option value="">Seleziona una categoria</option>
                      {categorieData.categorieFaq.map((categoria) => (
                        <option key={categoria.id} value={categoria.id}>
                          {categoria.titoloCategoria}
                        </option>
                      ))}
                    </select>

                    <button
                      onClick={handleSave}
                      className="bg-green-500 text-white px-4 py-2 rounded mr-2"
                    >
                      Salva
                    </button>
                    <button
                      onClick={cancelEditing}
                      className="bg-gray-500 text-white px-4 py-2 rounded"
                    >
                      Annulla
                    </button>
                  </div>
                ) : (
                  // Visualizzazione normale
                  <>
                    <div
                      className="flex items-center cursor-pointer"
                      onClick={() => toggleFAQ(index)}
                    >
                      <span
                        className={`w-4 h-4 border ${
                          item.open ? "border-blue-500" : ""
                        } rounded-full mr-4`}
                      ></span>
                      <h3 className="text-xl font-semibold text-gray-700 mr-auto">
                        {item.titoloFaq}
                      </h3>
                      <span className="text-blue-500">
                        {item.open ? "-" : "+"}
                      </span>
                    </div>
                    <div
                      className={`px-8 mt-2 ${item.open ? "block" : "hidden"}`}
                    >
                      <p>{item.descrizione}</p>
                      {item.categoriaFaq && (
                        <p className="text-sm text-gray-500 mt-1">
                          Categoria: {item.categoriaFaq.titoloCategoria}
                        </p>
                      )}
                      <div className="flex items-center mt-4 gap-3">
                        <button
                          onClick={() => startEditing(item)}
                          className="mt-2 bg-blue-500  hover:bg-blue-600 text-white px-4 py-2 rounded transition"
                        >
                          Modifica
                        </button>
                        <button
                          onClick={() => handleDeleteFAQ(item)}
                          className="mt-2 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
                        >
                          Elimina
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export const IconComponent = ({ iconName }) => {
  const SelectedIcon =
    Icons[iconName] || // Prova nella libreria Fa
    Fa6Icons[iconName] || // Prova nella libreria Fa6
    null; // Fallback se non trovato

  return (
    <div>
      {SelectedIcon ? (
        <SelectedIcon className="text-grey-500 text-2xl" />
      ) : (
        <span>Icona non trovata</span>
      )}
    </div>
  );
};

const GestioneCategorie = () => {
  const [categorie, setCategorie] = useState([]);
  const [newCategoria, setNewCategoria] = useState("");
  const [newIcon, setNewIcon] = useState(""); // Stato per la nuova icona
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState("");
  const [editIcon, setEditIcon] = useState(""); // Stato per l'icona in modifica

  const { data: categorieData, loading, error } = useQuery(CATEGORIE);
  const [addCategoria] = useMutation(ADD_CATEGORIA);
  const [updateCategoria] = useMutation(UPDATE_CATEGORIA);
  const [deleteCategoria] = useMutation(DELETE_CATEGORIA);

  useEffect(() => {
    console.log("categorieData:", categorieData);
    if (categorieData?.categorieFaq) {
      setCategorie(categorieData.categorieFaq);
    }
  }, [categorieData]);

  const handleAddCategoria = async () => {
    console.log("Aggiungi categoria:", newCategoria, newIcon);
    if (newCategoria.trim() === "") return;
    try {
      console.log(newIcon);
      const { data } = await addCategoria({
        variables: { titoloCategoria: newCategoria, icona: newIcon },
      });
      setCategorie([...categorie, data.createCategoriaFaq]);
      setNewCategoria("");
      setNewIcon("");
      window.location.reload();
    } catch (error) {
      console.error("Errore durante l'aggiunta della categoria:", error);
    }
  };

  const handleUpdateCategoria = async () => {
    if (editData.trim() === "") return;
    console.log("QUI");
    try {
      await updateCategoria({
        variables: {
          id: editingId,
          titoloCategoria: editData,
          icona: editIcon,
        },
      });
      setCategorie((prev) =>
        prev.map((cat) =>
          cat.id === editingId
            ? { ...cat, titoloCategoria: editData, icona: editIcon }
            : cat
        )
      );
      setEditingId(null);
      setEditData("");
      setEditIcon("");
    } catch (error) {
      console.error("Errore durante l'aggiornamento:", error);
    }
  };

  const handleDeleteCategoria = async (id) => {
    try {
      await deleteCategoria({ variables: { id } });
      setCategorie((prev) => prev.filter((cat) => cat.id !== id));
    } catch (error) {
      console.error("Errore durante l'eliminazione:", error);
    }
  };

  if (loading) return <p>Caricamento categorie...</p>;
  if (error) return <p>Errore durante il caricamento: {error.message}</p>;

  return (
    <div className="p-6 ">
      <h1 className="text-3xl font-bold mb-6">Gestione categorie</h1>

      <div className="flex items-center gap-4 mb-6">
        <input
          type="text"
          value={newCategoria}
          onChange={(e) => setNewCategoria(e.target.value)}
          placeholder="Inserisci nuova categoria"
          className="flex-grow p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <input
          type="text"
          value={newIcon}
          onChange={(e) => setNewIcon(e.target.value)}
          placeholder="Inserisci nome dell'icona (es. FaHome)"
          className="flex-grow p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          onClick={handleAddCategoria}
          className="flex items-center gap-2 bg-blue-600 text-white px-5 py-3 rounded shadow hover:bg-blue-700 transition"
        >
          <span>Aggiungi</span>
        </button>
      </div>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {categorie.map((categoria) => {
          // const IconComponent = Icons[categoria.icona] || null; // Fallback se l'icona non esiste
          return (
            <li
              key={categoria.id}
              className="flex flex-col sm:flex-row items-center justify-between gap-2 p-4 border rounded shadow hover:shadow-md transition"
            >
              {editingId === categoria.id ? (
                <div className="flex flex-col items-center gap-2 flex-grow">
                  <input
                    type="text"
                    value={editData || ""}
                    onChange={(e) => setEditData(e.target.value)}
                    className="flex-grow p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                  <input
                    type="text"
                    value={editIcon || ""}
                    onChange={(e) => setEditIcon(e.target.value)}
                    className="flex-grow p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
                    placeholder="Nome dell'icona"
                  />

                  <div className="flex gap-2">
                    <button
                      onClick={handleUpdateCategoria}
                      className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded shadow hover:bg-green-700 transition"
                    >
                      <span>Salva</span>
                    </button>
                    <button
                      onClick={() => setEditingId(null)}
                      className="flex items-center gap-2 bg-gray-500 text-white px-4 py-2 rounded shadow hover:bg-gray-600 transition"
                    >
                      <span>Annulla</span>
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col sm:flex-row items-center gap-2 flex-grow">
                  {IconComponent && (
                    <IconComponent
                      iconName={categoria.icona}
                      className="text-xl text-gray-700"
                    />
                  )}

                  <span className="flex-grow text-gray-700 font-medium">
                    {categoria.titoloCategoria}
                  </span>
                  <div className="flex gap-2">
                    <button
                      onClick={() => {
                        setEditingId(categoria.id);
                        setEditData(categoria.titoloCategoria);
                        setEditIcon(categoria.icona);
                      }}
                      className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded shadow hover:bg-blue-600 transition"
                    >
                      <span>Modifica</span>
                    </button>
                    <button
                      onClick={() => handleDeleteCategoria(categoria.id)}
                      className="flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded shadow hover:bg-red-700 transition"
                    >
                      <span>Elimina</span>
                    </button>
                  </div>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const App = () => (
  <ApolloProvider client={client}>
    <GestioneFAQs />
  </ApolloProvider>
);

export default App;
